import { render, staticRenderFns } from "./UploadMaps.vue?vue&type=template&id=64d915ee&scoped=true&"
import script from "./UploadMaps.vue?vue&type=script&lang=ts&"
export * from "./UploadMaps.vue?vue&type=script&lang=ts&"
import style0 from "./UploadMaps.vue?vue&type=style&index=0&id=64d915ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d915ee",
  null
  
)

export default component.exports